
import { creditStatus } from "./creditRequestMapping";
import { pascalEnumToString } from "./jbhTextFormatterUtil";

export function creditRequestStatusToColour(status) {
	if (!status) {
		return "";
	}

	switch (status) {
		default:
		case creditStatus.inProgress:
			return "grey";
		case creditStatus.draft:
			return "#bb45e6";
		case creditStatus.awaitingSupplier:
			return "#33ccff"; //royal blue
		case creditStatus.pendingReview:
			return "#ff9800"; //orange
		case creditStatus.reviewing:
			return "#000000"; //black
		case creditStatus.cancelled:
			return "#f44336"; //red
		case creditStatus.claimed:
			return "#4caf50"; //dark green
	}
}
export function statusToLabel(status) {
	return pascalEnumToString(status);
}
